import { Fragment } from 'react';
import About from './componentes/About';
import Footer from './componentes/Footer';
import Header from './componentes/Header';
import Home from './componentes/Home';
import Projects from './componentes/Projects';
import FAQ from './componentes/FAQ';
import Depoiments from './componentes/Depoiments';
import Contacts from './componentes/Contacts';
import HeaderMob from './componentes/Header/mobile';

function App() {
  return (
    <section style={{display: 'flex', flexDirection: 'column'}}>
      <Header />
      <Home />
      <Projects />
      <FAQ />
      <Depoiments />
      <Contacts />
      <Footer />
    </section>
  );
}

export default App;
